import * as React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material'
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import {
  DataGrid,
  GridToolbarDensitySelector,
  GridToolbarFilterButton,
  GridToolbarExport
} from '@mui/x-data-grid';
// import { useDemoData } from '@mui/x-data-grid-generator';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { createTheme } from '@mui/material/styles';
import { createStyles, makeStyles } from '@mui/styles';
import axios from 'axios';
import filedownload from 'react-file-download';
import XLSX from 'xlsx'

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import { darken, lighten } from '@mui/material/styles';

function escapeRegExp(value) {
  return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}

const defaultTheme = createTheme();
const useStyles = makeStyles(
  (theme) =>
    createStyles({
      root: {
        padding: theme.spacing(0.5, 0.5, 0),
        justifyContent: 'space-between',
        display: 'flex',
        alignItems: 'flex-start',
        flexWrap: 'wrap',
      },
      textField: {
        [theme.breakpoints.down('xs')]: {
          width: '100%',
        },
        margin: theme.spacing(1, 0.5, 1.5),
        '& .MuiSvgIcon-root': {
          marginRight: theme.spacing(0.5),
        },
        '& .MuiInput-underline:before': {
          borderBottom: `1px solid ${theme.palette.divider}`,
        },
      },
    }),
  { defaultTheme },
);

function QuickSearchToolbar(props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div>
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        {/* <GridToolbarExport /> */}
        <Button onClick={props.download}>Excel</Button>
      </div>
      <TextField
        variant="standard"
        value={props.value}
        onChange={props.onChange}
        placeholder="Search…"
        className={classes.textField}
        InputProps={{
          startAdornment: <SearchIcon fontSize="small" />,
          endAdornment: (
            <IconButton
              title="Clear"
              aria-label="Clear"
              size="small"
              style={{ visibility: props.value ? 'visible' : 'hidden' }}
              onClick={props.clearSearch}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          ),
        }}
      />
    </div>
  );
}

QuickSearchToolbar.propTypes = {
  clearSearch: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  download: PropTypes.func.isRequired,
};
function isOverflown(element) {
  return (
    element.scrollHeight > element.clientHeight ||
    element.scrollWidth > element.clientWidth
  );
}

const GridCellExpand = React.memo(function GridCellExpand(props) {
  const { width, value } = props;
  const wrapper = React.useRef(null);
  const cellDiv = React.useRef(null);
  const cellValue = React.useRef(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [showFullCell, setShowFullCell] = React.useState(false);
  const [showPopper, setShowPopper] = React.useState(false);

  const handleMouseEnter = () => {
    const isCurrentlyOverflown = isOverflown(cellValue.current);
    setShowPopper(isCurrentlyOverflown);
    setAnchorEl(cellDiv.current);
    setShowFullCell(true);
  };

  const handleMouseLeave = () => {
    setShowFullCell(false);
  };

  React.useEffect(() => {
    if (!showFullCell) {
      return undefined;
    }

    function handleKeyDown(nativeEvent) {
      // IE11, Edge (prior to using Bink?) use 'Esc'
      if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') {
        setShowFullCell(false);
      }
    }

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [setShowFullCell, showFullCell]);

  return (
    <Box
      ref={wrapper}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      sx={{
        alignItems: 'center',
        lineHeight: '24px',
        width: 1,
        height: 1,
        position: 'relative',
        display: 'flex',
      }}
    >
      <Box
        ref={cellDiv}
        sx={{
          height: 1,
          width,
          display: 'block',
          position: 'absolute',
          top: 0,
        }}
      />
      <Box
        ref={cellValue}
        sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
      >
        {value}
      </Box>
      {showPopper && (
        <Popper
          open={showFullCell && anchorEl !== null}
          anchorEl={anchorEl}
          style={{ width, marginLeft: -17 }}
        >
          <Paper
            elevation={1}
            style={{ minHeight: wrapper.current.offsetHeight - 3 }}
          >
            <Typography variant="body2" style={{ padding: 8 }}>
              {value}
            </Typography>
          </Paper>
        </Popper>
      )}
    </Box>
  );
});

GridCellExpand.propTypes = {
  value: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
};

function renderCellExpand(params) {
  return (
    <GridCellExpand value={params.value || ''} width={params.colDef.computedWidth} />
  );
}

renderCellExpand.propTypes = {
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: PropTypes.object.isRequired,
  /**
   * The cell value, but if the column has valueGetter, use getValue.
   */
  value: PropTypes.string.isRequired,
};
export default function QuickFilteringGrid(props) {
  // const { data } = useDemoData({
  //   dataSet: 'Commodity',
  //   rowLength: 100,
  //   maxColumns: 6,
  // });

  const [apiUrl, setapiUrl] = React.useState("http://reportapi.bestbilgisayar.info/");
  const [searchText, setSearchText] = React.useState('');
  const [rows, setRows] = React.useState(props.data);
  const [open, setOpen] = React.useState(false);
  function downloadExcel() {

    const newData = rows.map(row => {
      delete row.NumunePdfId
      delete row.id
      delete row.KurumKod
      delete row.AltNo
      return row
    })
    const workSheet = XLSX.utils.json_to_sheet(newData)
    const workBook = XLSX.utils.book_new()

    XLSX.utils.book_append_sheet(workBook, workSheet, "sonuc")
    //Buffer
    let buf = XLSX.write(workBook, { bookType: "xlsx", type: "buffer" })
    //Binary string
    XLSX.write(workBook, { bookType: "xlsx", type: "binary" })
    //Download
    XLSX.writeFile(workBook, "Sonuc.xlsx")


  }
  function indir(item, dosyaAd) {
    console.log(item)
    // var a = item.DosyaAd;
    // var temp = [];
    // temp = a.split('/');
    handleToggle()
    var urll = apiUrl + 'numunePdf/indir/' + item;
    axios({
      method: 'get',
      url: urll,
      responseType: 'arraybuffer',
      headers: {
        'authorization': 'Basic dXNlcm5hbWU6cGFzc3dvcmQ='
      }
    })
      .then(function (response) {
        handleClose()
        filedownload(response.data, `${dosyaAd}.pdf`);
      });
  }
  const requestSearch = (searchValue) => {
    setSearchText(searchValue);
    const searchRegex = new RegExp(escapeRegExp(searchValue), 'i');
    const filteredRows = props.data.filter((row) => {
      return Object.keys(row).some((field) => {
        if (row[field] != null)
          return searchRegex.test(row[field].toString());
      });
    });
    setRows(filteredRows);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleToggle = () => {
    setOpen(!open);
  };
  React.useEffect(() => {
    setRows(props.data);
  }, [props.data]);
  const columns = [
    { field: 'id', headerName: 'ID', hide: true },
    {
      field: 'Tarih',
      headerName: 'Tarih',
      type: 'date',
      editable: false,
      minWidth: "105",
      maxWidth: "110",
      // renderCell: renderCellExpand,
    },
    {
      field: 'RaporNo',
      headerName: 'Rapor No',
      editable: false,
      // flex: 0.8,
      minWidth: "105",
      maxWidth: "110",
    },
    {
      field: 'NumuneAdi',
      headerName: 'Numune Adı',
      // type: 'number',
      flex: 1,
      editable: false,
      // minWidth:"200",
      renderCell: renderCellExpand
    },
    {
      field: 'AlimYeri',
      headerName: 'Alım Yeri',
      // type: 'number',
      // width: 110,
      // minWidth:"150",
      flex: 1,
      renderCell: renderCellExpand,
      editable: false,
    },
    {
      field: 'NumuneTipi',
      headerName: 'Numune Tipi',
      // type: 'number',
      // width: 110,
      // flex: 1,
      editable: false,
      minWidth: "50",
      renderCell: renderCellExpand
    },
    {
      field: 'SonucDurum',
      headerName: 'Sonuç Durum',
      // type: 'number',
      // width: 110,
      // flex: 1,
      editable: false,
      maxWidth: "50px",
    },
    {
      field: 'NumuneAciklama',
      headerName: 'Numune Açıklama',
      // type: 'number',
      // width: 110,
      minWidth: "20",
      renderCell: renderCellExpand,
      editable: false,
    },
    {
      field: 'NumunePdfId',
      headerName: 'İşlemler',
      // type: 'number',
      // width: 110,
      // flex: 1,
      editable: false,
      sortable: false,
      maxWidth: "50px",
      renderCell: (params) => {
        let d = params.getValue(params.id, 'NumunePdfId')
        let raporNo = params.getValue(params.id, 'RaporNo')
        const onClick = (e) => {
          e.stopPropagation(); // don't select this row after clicking

          console.log(d)
          // const api: GridApi = params.api;
          // const thisRow: Record<string, GridCellValue> = {};

          // api
          //   .getAllColumns()
          //   .filter((c) => c.field !== '__check__' && !!c)
          //   .forEach(
          //     (c) => (thisRow[c.field] = params.getValue(params.id, c.field)),
          //   );

          // return alert(JSON.stringify(thisRow, null, 4));
        };

        return <Button onClick={() => indir(d, raporNo)}>İndir</Button>;
      },
    },
    //   {
    //     field: 'fullName',
    //     headerName: 'Full name',
    //     description: 'This column has a value getter and is not sortable.',
    //     sortable: false,
    //     width: 160,
    //     valueGetter: (params) =>
    //       `${params.getValue(params.id, 'firstName') || ''} ${
    //         params.getValue(params.id, 'lastName') || ''
    //       }`,
    //   },
  ];
  const getBackgroundColor = (color, mode) =>
    mode === 'dark' ? darken(color, 0.6) : lighten(color, 0.6);

  const getHoverBackgroundColor = (color, mode) =>
    mode === 'dark' ? darken(color, 0.5) : lighten(color, 0.5);
  return (
    <div style={{ height: 400, width: '100%' }}>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 10000000000 }}
        open={open}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box
        sx={{
          height: 400,
          width: 1,
          '& .super-app-theme--Olumlu': {
            bgcolor: (theme) =>
              getBackgroundColor(theme.palette.info.main, theme.palette.mode),
            '&:hover': {
              bgcolor: (theme) =>
                getHoverBackgroundColor(theme.palette.info.main, theme.palette.mode),
            },
          },
          '& .super-app-theme--Filled': {
            bgcolor: (theme) =>
              getBackgroundColor(theme.palette.success.main, theme.palette.mode),
            '&:hover': {
              bgcolor: (theme) =>
                getHoverBackgroundColor(
                  theme.palette.success.main,
                  theme.palette.mode,
                ),
            },
          },
          '& .super-app-theme--PartiallyFilled': {
            bgcolor: (theme) =>
              getBackgroundColor(theme.palette.warning.main, theme.palette.mode),
            '&:hover': {
              bgcolor: (theme) =>
                getHoverBackgroundColor(
                  theme.palette.warning.main,
                  theme.palette.mode,
                ),
            },
          },
          '& .super-app-theme--Olumsuz': {
            bgcolor: (theme) =>
              getBackgroundColor(theme.palette.error.main, theme.palette.mode),
            '&:hover': {
              bgcolor: (theme) =>
                getHoverBackgroundColor(theme.palette.error.main, theme.palette.mode),
            },
          },
        }}
      >
        <DataGrid
        getRowClassName={(params) => `super-app-theme--${params.row.SonucDurum}`}
          csvOptions={{ allColumns: true }}
          components={{ Toolbar: QuickSearchToolbar }}
          rows={rows}
          // rowHeight={50}
          columns={columns}
          // rowsPerPageOptions={
          //   {
          //     expandableRows: true,
          //     responsive: "scrollMaxHeight"
          //   }
          // }
          componentsProps={{
            toolbar: {
              value: searchText,
              onChange: (event) => requestSearch(event.target.value),
              clearSearch: () => requestSearch(''),
              download: () => downloadExcel()
            },
          }}
        />
      </Box>
    </div>
  );
}
